import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedCloseBoldRedIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.36832 15.8533L10.2216 12L6.36832 8.14675C5.87723 7.65565 5.87723 6.85942 6.36832 6.36832C6.85942 5.87723 7.65565 5.87723 8.14675 6.36832L12 10.2216L15.8533 6.36832C16.3443 5.87723 17.1406 5.87723 17.6317 6.36832C18.1228 6.85942 18.1228 7.65565 17.6317 8.14675L13.7784 12L17.6317 15.8533C18.1228 16.3443 18.1228 17.1406 17.6317 17.6317C17.1406 18.1228 16.3443 18.1228 15.8533 17.6317L12 13.7784L8.14675 17.6317C7.65565 18.1228 6.85942 18.1228 6.36832 17.6317C5.87723 17.1406 5.87723 16.3443 6.36832 15.8533Z",
		fill: "#D41F24"
	})]
});
const ForwardRef = forwardRef(SvgOutlinedCloseBoldRedIcon);
const Memo = memo(ForwardRef);
export default Memo;
